import React, { FC, useMemo } from 'react'

import Container from '@Components/CMS/Container'
import { Block } from '@Generated/graphql'
import { getJSONFieldValue } from '@Globals/CMS/FieldHelpers'

type CodeBlockWidth = 'column' | 'small' | 'medium' | 'large'

const widthToContainerWidth = (width?: CodeBlockWidth): 'small' | 'medium' | 'wide' => {
  switch (width) {
    case 'medium':
      return 'medium'
    case 'large':
    case 'column':
      return 'wide'
    default:
      return 'small'
  }
}

interface EmbedCodeBlockData {
  code: string
  width: 'small' | 'medium' | 'wide'
}

const getBlockData = (embedCodeBlock: Block): EmbedCodeBlockData => ({
  code: getJSONFieldValue(embedCodeBlock.fields || [], 'codeString') || '',
  width: widthToContainerWidth(getJSONFieldValue<CodeBlockWidth>(embedCodeBlock.fields || [], 'width') || undefined),
})

interface EmbedCodeBlockProps {
  embedCodeBlock: Block
  id?: string
}

const EmbedCodeBlock: FC<EmbedCodeBlockProps> = ({ embedCodeBlock, id }) => {
  const { code, width } = useMemo(() => getBlockData(embedCodeBlock), [embedCodeBlock])

  return (
    <Container id={id} width={width}>
      <div dangerouslySetInnerHTML={{ __html: code }} />
    </Container>
  )
}

export default EmbedCodeBlock
